<template lang="pug">
  section.about#about
    .container-fluid(v-if="lang==='ru'")
      .row
        .col
          h2.title О компании
          p.text-white Наша компания — новый независимый
          p.text-white высокопрофессиональный игрок на рынке ж/д
          p.text-white перевозок контейнеров
      .row
        .col-3
          h1.title 2018
          h3.text-white Год основания
          h3.text-white компании
          //- h3.text-white «Новая логистическая»
        .col-3
          h1.title 2020
          h3.text-white Вагонов
          h3.text-white парк компании
          h3.text-white
        .col-3
          //- 2 500
          h1.title 847
          h3.text-white 40-футовых контейнеров
          h3.text-white в собственности
          h3.text-white Дальнейшее развитие парка
          h3.text-white вагонов/контейнеров
    .container-fluid(v-if="lang==='en'")
      .row
        .col
          h2.title About us
          p.text-white Our company is a new independent
          p.text-white highly professional player in railway container
          p.text-white rail transportation market
      .row
        .col-3
          h1.title 2018
          h3.text-white Company
          h3.text-white founded
          //- h3.text-white «Новая логистическая»
        .col-3
          h1.title 2020
          h3.text-white flatcars 
          h3.text-white operated
          h3.text-white
        .col-3
          h1.title 847
          //- 2 500
          h3.text-white containers
          h3.text-white owned
          h3.text-white by the company
</template>

<script lang="js">
  export default {
    name: 'about',
    props: {
      lang: String
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
  .about {
    position: relative;
    height: 40vw;
    background-image: url('~@/assets/containers.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 3;

    .text-white {
      font-weight: 500;
      font-size: 1.4vw;
    }
  }
</style>
